import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import i18n from './vuei18n'

import Pl from "@/locale/flags/Pl";
import En from "@/locale/flags/En";

Vue.use(Vuetify)

const opts = {
    lang: {
        t: (key, ...params) => i18n.t(key, params)
    },
    icons: {
        iconfont: 'mdi',
        values: {
            pl: {
                component: Pl
            },
            en: {
                component: En
            }
        },
    },
    theme: {
        themes: {
            light: {
                primary: '#abc654',
            },
        },
    }
}

export default new Vuetify(opts)
